/**
 * User cancelled flight date picker
 */
export class FlightDatePickerCancelledError extends Error {
  constructor(message = 'Scan date picker cancelled') {
    super(message);
    this.name = 'ScanDatePickerCancelledError';
  }
}
